'use client'

import { Suspense } from 'react'
import { AuthForm } from '@/components/auth/auth-form'
import { useAuthPageEffects } from '@/hooks/useAuthPageEffects'
import { Skeleton } from '@/components/ui/skeleton'

function SignupPageContent() {
  useAuthPageEffects({ 
    route: '/signup',
    trackFramerEvent: true,
    handleReferralCode: true
  })

  return (
    <AuthForm 
      title="Sign up for atrium"
      subtitle="Choose your preferred authentication method"
      showTerms={true}
      redirectPath="/campaigns"
      isSignup={true}
      switchAuthLink={{
        text: "Already have an account?",
        linkText: "Log in",
        href: "/login"
      }}
    />
  )
}

function SignupFallback() {
  return (
    <div className="mx-auto flex w-full max-w-md flex-col items-center gap-4 px-4 py-6 sm:px-6">
      <Skeleton className="h-8 w-52 rounded-md" />
      <Skeleton className="h-4 w-full max-w-sm rounded-md" />
      <Skeleton className="h-11 w-full max-w-sm rounded-md" />
      <Skeleton className="h-11 w-full max-w-sm rounded-md" />
      <Skeleton className="h-11 w-full max-w-sm rounded-md" />
    </div>
  )
}

export default function SignupPage() {
  return (
    <Suspense fallback={<SignupFallback />}>
      <SignupPageContent />
    </Suspense>
  )
}